module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/matera.318b1cafebd71128aad55b929b6b0f20.jpg";